import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'onlyDigits',
  standalone: true
})
export class OnlyDigitsPipe implements PipeTransform {

  constructor(private decimal: DecimalPipe) {}

  transform(value: string | number, format: string = ''): string | null {
    if (value == null) return null;

    const digits = value.toString().replace(/\D+/g, '');
    if (!digits) return null;

    return this.decimal.transform(Number(digits), format);
  }
}
